/** Raw per-player input snapshot, normalized to [-1, 1]. Filled by InputSystem each tick. */
export interface PlayerInput {
  moveX: number;
  moveY: number;
  aimX: number;
  aimY: number;
  /** True when aim comes from an absolute pointer (mouse) rather than a stick. */
  aimIsPointer: boolean;
  /**
   * True while the player is deliberately aiming: stick past the deadzone, fire held,
   * or the mouse moved within the last few hundred ms. A parked mouse is not aiming.
   */
  aiming: boolean;
  fire: boolean;
  connected: boolean;
  /** Cardinal bits this frame: 1 right, 2 left, 4 up, 8 down. Keys, d-pad, and stick flicks. */
  digital: number;
}

export const MAX_PLAYERS = 4;

export function createPlayerInput(): PlayerInput {
  return { moveX: 0, moveY: 0, aimX: 1, aimY: 0, aimIsPointer: false, aiming: false, fire: false, connected: false, digital: 0 };
}
